/** TOGAPhotos wordmark served from the brand CDN; the masthead and the footer share it. */
export const LOGO_URL = 'https://cos-125-tp-cdn.794td.cn/assets/n_logo_b.jpg?imageMogr2/thumbnail/480x/format/webp';
export const LOGO_WIDTH = 1484;
export const LOGO_HEIGHT = 188;
